import React, { Component } from 'react'
import { Route, NavLink, Link, Redirect, Switch } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ComponentList from './componentList.jsx'
import { tabListData } from './fixtures.js'
import ReferrerCode from './ReferrerCode/index.jsx'

export default class Settings extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedTab: 'profile',
            referrer_code: '',
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    render() {
        let { path } = this.props.match
        let { referrer_code } = this.state

        let liTabList = tabListData.map((item, i) => {
            if (item.key === this.state.selectedTab) {
                return this.liTemplate(item, i)
            } else {
                return (
                    <NavLink to={`${path}/${item.key}`} key={i}>
                        {this.liTemplate(item, i)}
                    </NavLink>
                )
            }
        })

        return (
            <div className="settings-page">
                <div className="settings-page__header">
                    <h2>{this.translation['Settings']}</h2>
                    <hr />
                </div>
                {this.state.referrer_code ? (
                    <div className="settings-page__content">
                        <div className="profile">
                            <ul className="profile__tab-list">{liTabList}</ul>
                            <MediaQuery query="(min-width: 50em)">
                                {matches => {
                                    return matches ? this.routeSettings() : null
                                }}
                            </MediaQuery>
                        </div>
                    </div>
                ) : null}
                <ReferrerCode
                    referrerCode={this.state.referrer_code}
                    changeReferrerCode={this.changeReferrerCode}
                />
            </div>
        )
    }

    liTemplate = (item, i) => {
        return (
            <li
                key={item.key === this.state.selectedTab ? i : null}
                className={
                    item.key === this.state.selectedTab
                        ? 'profile__tab-list activeTab'
                        : null
                }
            >
                {this.translation[item.title]}
                <FontAwesomeIcon
                    className="profile__icon profile__icon_list"
                    icon={'angle-right'}
                />
                <MediaQuery query="(min-width: 50em)">
                    {matches => {
                        return !matches && item.key === this.state.selectedTab
                            ? this.routeSettings()
                            : null
                    }}
                </MediaQuery>
            </li>
        )
    }

    changeReferrerCode = referrer_code => {
        this.setState({
            referrer_code,
        })
    }

    switchSelectedTab = selectedTab => {
        this.setState({
            selectedTab,
        })
    }

    routeSettings = () => {
        let { path } = this.props.match
        return (
            <Switch>
                <Route
                    path={`${path}/:id`}
                    render={props => (
                        <ComponentList
                            {...props}
                            selectedTab={this.state.selectedTab}
                            switchSelectedTab={this.switchSelectedTab}
                            tfaCodeRequestRequired={
                                this.props.tfaCodeRequestRequired
                            }
                            tfaType={this.props.tfaType}
                            getStatus={this.props.getStatus}
                        />
                    )}
                />
                <Redirect
                    from="/investor/settings"
                    to="/investor/settings/profile"
                />
            </Switch>
        )
    }
}
